import { ClassProvider, Type } from '@angular/core';
import { NotificationService } from '../services/notification.service';

export const provideNotificationService = (notificationService: Type<any>) =>
  ({ provide: NotificationService, useClass: notificationService } satisfies ClassProvider);
